import { observer } from 'mobx-react';
import { useDataProvider } from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import {
  useServiceProvider,
  withServiceProvider,
} from '../../../../../providers/ServiceProviderProvider';
import SkillsSetup from '../../../components/SkillsSetup';
import getConfig from '../../../configs/sp-location-config';
import ServiceProviderLayout from '../../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../../utils/getSPLevelStackableButtons';

function LocationSkills() {
  const { serviceProviderId, locationId, refreshData } = useServiceProvider();
  const navigate = useNavigate();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl } = useDataProvider(provider);

  const config = getConfig({
    apiBaseUrl: getApiUrl(),
    serviceProviderId,
    locationId,
  });

  const onChange = () => {
    refreshData({
      refreshLocation: true,
      refreshProfileWarnings: true,
    });
  };

  return (
    <ServiceProviderLayout
      selectedStepperId="LOCATION_SKILLS"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <SkillsSetup
        permissionName="SERVICEPROVIDERSKILLS"
        config={config}
        onChange={onChange}
        pageSectionLabel={
          <FormattedMessage
            id="SERVICE_PROVIDER_LOCATION_SKILLS"
            defaultMessage="Service Provider Location Skills"
          />
        }
      />
    </ServiceProviderLayout>
  );
}

const LocationSkillsObserver = observer(LocationSkills);
export default withServiceProvider(LocationSkillsObserver);
